import {
    HardwareNotificationSubscriptionResponse,
    HardwareNotificationSubscriptionUpdateRequest,
    HardwareNotificationTriggerRequestChild,
    IHardwareNotificationTriggerRequestChild,
} from '@kcftech/prometheustypescriptapiclient';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

/**
 * Configuration object for editing hardware notification subscriptions.
 */
export type EditHardwareNotificationSubscription = Readonly<{
    /**
     * Id of the notification subscription to edit.
     */
    id: string;
    /**
     * Whether or not this notification should be silenced. Defaults to `false`.
     */
    isSilenced?: boolean;
    /**
     * The types of events that will trigger notifications for this subscription.
     */
    triggers: IHardwareNotificationTriggerRequestChild[];
}>;

export function editHardwareNotificationSubscription({
    id,
    isSilenced = false,
    triggers,
}: EditHardwareNotificationSubscription) {
    return sdClient.updateHardwareNotificationSubscription({
        subscriptionId: id,
        body: new HardwareNotificationSubscriptionUpdateRequest({
            IsSilenced: isSilenced,
            NotificationTriggers: triggers.map(
                (trigger) => new HardwareNotificationTriggerRequestChild(trigger)
            ),
        }),
    });
}

/** Type of data returned by mutation function */
type Data = HardwareNotificationSubscriptionResponse;

/** The mutation options object type */
type Options = UseMutationOptions<Data, unknown, EditHardwareNotificationSubscription>;

export function useEditHardwareNotificationSubscription(options: Options) {
    return useMutation<Data, unknown, EditHardwareNotificationSubscription>({
        mutationFn: (args) => editHardwareNotificationSubscription(args),
        ...options,
    });
}
